import type { TimeEntryFilters } from '@/store/time-entry-filters.store'
import { toDateOnlyString } from '@/utils/date'

import type { PaginationParams } from '@scrambl/shared'

/** The personal list and its export must select the same records. */
export function personalTimeParams(
  filters: TimeEntryFilters | undefined,
  dateBasis: 'recorded' | 'display',
  timezone?: string,
): Partial<PaginationParams> & Record<string, unknown> {
  const params: Partial<PaginationParams> & Record<string, unknown> = {
    page: filters?.page || 1,
    limit: filters?.limit || 50,
    sortBy: filters?.sortBy,
    sortOrder: filters?.sortOrder,
    dateBasis,
    ...(dateBasis === 'display' && timezone ? { timezone } : {}),
  }
  for (const key of [
    'description',
    'status',
    'entityId',
    'projectId',
    'taskId',
    'moduleType',
  ] as const) {
    const value = filters?.[key]?.trim()
    if (value) params[key] = value
  }
  if (filters?.billable !== undefined) params.billable = filters.billable
  if (filters?.dateRange?.from)
    params.startDate = toDateOnlyString(filters.dateRange.from)
  if (filters?.dateRange?.to)
    params.endDate = toDateOnlyString(filters.dateRange.to)
  // Ownership comes from the authenticated personal endpoint, never persisted filters.
  return params
}
